
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'CombinationsSelectorProgressBar',
})
export default class CombinationsSelectorProgressBar extends Vue {
    @Prop({ required: true, default: 1 }) private currentStep!: number;
    @Prop({ required: true, default: 4 }) private totalSteps!: number;
    @Prop({ required: false, default: () => ['Step 1', 'Step 2', 'Step 3', 'Step 4'] }) private stepLabels!: string[];
    @Prop({ required: false, default: () => [true, false, false] }) private stepsAccessible!: boolean[];

    private navigateToStep(step: number) {
        // Only allow navigating to accessible steps
        if (this.stepsAccessible[step - 1]) {
            this.$emit('step-change', step);
        }
    }
}
